
    <div class="photo-map-container">
      <div class="photo-map-header">
        <div class="photo-map-title">
          <mat-icon style="margin-right: 8px; color: #1a73e8;">place</mat-icon>
          Photo Location
        </div>
        <button mat-icon-button [mat-dialog-close]="true" aria-label="Close">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="photo-map-meta">
        <div class="photo-map-meta-left">
          <div class="photo-map-caption">{{ data.caption }}</div>
          <div class="photo-map-coords">{{ data.lat | number:'1.5-5' }}, {{ data.lng | number:'1.5-5' }}</div>
        </div>
        <a [href]="googleMapsLink" target="_blank" rel="noopener" mat-stroked-button color="primary">
          <mat-icon style="margin-right: 4px;">open_in_new</mat-icon>
          Open in Google Maps
        </a>
      </div>

      <div class="photo-map-image-wrapper">
        <img
          *ngIf="staticMapUrl"
          [src]="staticMapUrl"
          alt="Map showing photo location"
          class="photo-map-image"
          (error)="onMapError()"
        />
        <div *ngIf="loadError" class="photo-map-error">
          <mat-icon style="font-size: 32px; height: 32px; width: 32px; color: #999;">map</mat-icon>
          <span>Map failed to load</span>
        </div>
      </div>
    </div>
  